// extracted by mini-css-extract-plugin
export default {"content":"style_content__1o1X2"};